<script>
import { RecordsData } from '../../../api/visitRecords';
import * as echarts from 'echarts';
export default {
  components: {},
  data() {
    return {
      selectTime: {},
      satisfaction: [],
      analyst: [],
      discontentItem: [],
      reason: [],
      Ldata: [],
      Sdata: [],
      heightSZ: ''
    };
  },
  async created() {
    this.selectTime = this.$route.query
    const formdata = new FormData()
    formdata.append('year', this.selectTime.year)
    formdata.append('month', this.selectTime.month)
    const result = await RecordsData(formdata)
    console.log(result);
    if (result.code == 0) {
      this.satisfaction = result.data.satisfaction
      this.analyst = result.data.analyst
      this.heightSZ = +this.analyst.length + 1
      console.log(this.heightSZ);
      this.discontentItem = result.data.discontentItem
      this.reason = result.data.reason
      this.Ldata = this.discontentItem.map(item => item.reason)
      for (let i = 0; i < this.discontentItem.length; i++) {
        const muban = {
          value: '',
          name: ''
        }
        muban.value = this.discontentItem[i].ratio
        muban.name = this.discontentItem[i].reason
        this.Sdata.push(muban)
      }
      this.initChart();
    } else {
      this.$notify.error({
        title: this.$t('messages.error'),
        message: result.message
      });
    }
  },
  methods: {
    returnR() {
      this.$router.push('/visitRecords')
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 10 === 0) {
          return {
            rowspan: 10,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    initChart() {
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);

      var option = {
        title: {
          text: this.$t('visitRecords.minusScoreReason'),
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: [...this.Ldata]
        },
        series: [
          {
            type: 'pie',
            radius: '65%',
            center: ['50%', '50%'],
            selectedMode: 'single',
            data: [
              ...this.Sdata
            ],
            label: {
              formatter: '{b}\n{c}%',
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
    }

  },
};
</script>
<template>
  <div>
    <div style="width: 100%; height: 100%">
      <div class="equipmentList">
        <div class="container">
          <div>

          </div>

          <div>
            <a-space>
              <a-button type="primary" @click="returnR">
                {{ $t('buttons.goBack') }}</a-button>
            </a-space>
          </div>

        </div>
        <div style="position: relative;">
          <!-- 2-1 -->
          <div style="display: inline-block;">
            <el-table :data="satisfaction" style="width: 100%">
              <el-table-column :label="selectTime.month + this.$t('visitRecords.statisticsMonth')">
                <el-table-column prop="dept" :label="$t('visitRecords.team')" width="150">
                </el-table-column><el-table-column prop="totalVisits" :label="$t('visitRecords.totalVisits')"
                  width="150">
                </el-table-column><el-table-column prop="satisfactionNum" :label="$t('visitRecords.satisfactionNum')"
                  width="150">
                </el-table-column><el-table-column prop="satisfactionRate" :label="$t('visitRecords.satisfactionRate')"
                  width="150">
                  <template slot-scope="scope">
                    {{ scope.row.satisfactionRate }}%
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
          <div style="width: 100%;height: 1px;display: inline-block;"></div>
          <!-- 3-1 -->
          <div>
            <h2 class="tableTitle" tooltip="1111111">{{ selectTime.year }}{{ $t('visitRecords.year') }}{{
              selectTime.month }}{{
                $t('visitRecords.month') }}{{ $t('visitRecords.analyse') }}</h2>
            <div style="display: flex;border-top: 1px solid black;width: 1650px;height: 301px;">
              <div style="width: 45%;height: 200px;border-left: 1px solid black;">
                <div style="height: 20%;width: 100%;display: flex;">
                  <div
                    style="height: 100%;width: 25%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #9bc2e6;"
                    class="zi">{{ $t('visitRecords.totalVisits') }}</div>
                  <div
                    style="height: 100%;width: 50%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #9bc2e6;"
                    class="zi">{{ $t('visitRecords.success') }}</div>
                  <div
                    style="height: 100%;width: 25%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #9bc2e6;"
                    class="zi">{{ $t('visitRecords.ratio') }}</div>
                </div>
                <div style="height: 80%;width: 100%;display: flex;">
                  <div
                    style="height: 100%;width: 25%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #c6e0b4"
                    class="zi">{{ analyst[0] ? analyst[0].totalvisits : '' }}</div>
                  <!-- 回访成功下方 -->
                  <div style="height: 100%;width: 50%;">
                    <div
                      style="height: 25%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #c6e0b4"
                      class="zi">
                      {{ analyst[0] ? analyst[0].successfulVisits : '' }}
                    </div>
                    <!-- 满分占比 -->
                    <div style="height: 75%;width: 100%;display: flex;">
                      <div style="height: 100%;width: 40%;border-right: 1px solid black;border-bottom: 1px solid black;"
                        class="zi">{{ $t('visitRecords.ratio') }}</div>
                      <div style="height: 100%;width: 60%;">
                        <div
                          style="height: 33.333%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;"
                          class="zi">{{ $t('visitRecords.fullScore') }}</div>
                        <div
                          style="height: 33.333%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;"
                          class="zi">{{ analyst[0] ? analyst[0].successfulFullScore : '' }}</div>
                        <div
                          style="height: 33.333%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;"
                          class="zi">{{ analyst[0] ? analyst[0].successfulFullScoreRatio : '' }}%</div>
                      </div>
                    </div>
                  </div>
                  <!-- 占比下方 -->
                  <div style="height: 100%;width: 25%;">
                    <div
                      style="height: 25%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #c6e0b4"
                      class="zi">{{ analyst[0] ? analyst[0].successfulRatio : '' }}%</div>
                    <div style="height: 75%;width: 100%;">
                      <div
                        style="height: 33.333%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;"
                        class="zi">{{ $t('visitRecords.minusScore') }}</div>
                      <div
                        style="height: 33.333%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;"
                        class="zi">{{ analyst[0] ? analyst[0].successfulNoFullScore : '' }}</div>
                      <div
                        style="height: 33.333%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;"
                        class="zi">{{ analyst[0] ? analyst[0].successfulNoFullScoreRatio : '' }}%</div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- 不成功 -->
              <div style="width: 55%;height: 200px;">
                <div style="height: 40%;width: 100%;display: flex;">
                  <div style="height: 100%;width: 50%;">
                    <div
                      style="height: 50%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #9bc2e6;"
                      class="zi">{{ $t('visitRecords.fail') }}</div>
                    <div
                      style="height: 50%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #c6e0b4"
                      class="zi">{{ analyst[0] ? analyst[0].failedVisits : '' }}</div>
                  </div>
                  <div style="height: 100%;width: 50%;">
                    <div
                      style="height: 50%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #9bc2e6;"
                      class="zi">{{ $t('visitRecords.ratio') }}</div>
                    <div
                      style="height: 50%;width: 100%;border-right: 1px solid black;border-bottom: 1px solid black;background-color: #c6e0b4"
                      class="zi">{{ analyst[0] ? analyst[0].failedRatio : '' }}%</div>
                  </div>
                </div>
                <div style="height: 60%;width: 100%; display: flex;">
                  <div :style="{ height: '100%', width: `calc(100%/${heightSZ})` }">
                    <div
                      style="width: 100%;height: 33.33%;border-right: 1px solid black;border-bottom: 1px solid black;"
                      class="zi">{{ $t('visitRecords.failReason') }}</div>
                    <div
                      style="width: 100%;height: 66.67%;border-right: 1px solid black;border-bottom: 1px solid black;"
                      class="zi">{{ $t('visitRecords.ratio') }}</div>
                  </div>

                  <div :style="{ height: '100%', width: `calc(100%/${heightSZ})` }" v-for="(i, index) in analyst"
                    :key="index">
                    <el-tooltip class="item" effect="light" :content="i.failedReason" placement="top">
                      <div
                        style="width: 100%;height: 33.33%;border-right: 1px solid black;border-bottom: 1px solid black;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                        :tooltip="i.failedReason" class="zi">

                        {{ i.failedReason }}
                      </div>
                    </el-tooltip>
                    <div
                      style="width: 100%;height: 33.33%;border-right: 1px solid black;border-bottom: 1px solid black;"
                      class="zi">{{ i.num }}</div>
                    <div
                      style="width: 100%;height: 33.34%;border-right: 1px solid black;border-bottom: 1px solid black;"
                      class="zi">{{ i.ratio }}%</div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div></div>

          <!-- 3-2 -->
          <div style="display: flex; position: relative">
            <div style="display: inline-block;">
              <el-table :data="discontentItem" style="width: 100%" border>
                <el-table-column prop="reason" :label="$t('visitRecords.minusScoreReasonIF')" width="260">
                </el-table-column><el-table-column prop="num" :label="$t('visitRecords.num')" width="150">
                </el-table-column><el-table-column prop="ratio" :label="$t('visitRecords.ratio')" width="150">
                  <template slot-scope="scope">
                    {{ scope.row.ratio }}%
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="width: 600px; height: 400px;position: absolute;left: 600px;z-index: 10;top: 0;">
              <div id="main" style="width: 100%; height: 100%">
              </div>
            </div>
          </div>
          <!-- 3-3 -->
          <div style="margin-top: 80px;width: 612px;">
            <div v-for="item in reason" style="margin-top: 5px;">
              <el-table :data="item.reasonsInfo" :span-method="arraySpanMethod" border>
                <el-table-column prop="dept" :label="$t('visitRecords.team')" width="140">
                </el-table-column>
                <el-table-column prop="customer" :label="$t('customer.company')" width="170">
                </el-table-column>
                <el-table-column prop="question" :label="$t('runningData.type')" width="150">
                </el-table-column>
                <el-table-column prop="note" :label="$t('visitRecords.minusScoreReason')" width="150">
                </el-table-column>

              </el-table>

            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>


<style lang="less" scoped>
.zi {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.row {
  margin-top: 5px;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.equipmentList {
  padding: 15px;

  height: 100%;
}

.equipmentList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;

}

.tableTitle {
  background-color: #9bc2e6;
  text-align: center;
  margin-bottom: 0;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-bottom: 0;
  padding: 10px 0;
  width: 1650px;
}
</style>
